import { useCallback, useEffect } from "react";
import TableView from "../components/TableView";
import SettingTableAction from "../generatedTableActions/SettingTableAction";
import Button from "../components/Button";
import Badge from "../components/Badge";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  setCurrentPage,
  setPerPage,
  setLoading,
  setSetting,
  setSearchTerm,
} from "../generatedSlice/settingSlice";
import useSearchApi from "../customHooks/useSearchApi";
import { getSetting } from "../generatedRequest/setting";
import { toast } from "react-toastify";
import TableSkeleton from "../components/TableSkeleton";
import SettingList from "../generatedTableList/SettingList";
import { TTableProps } from "../types/TableView";
import TableLoader from "../utils/Loaders/tableLoader";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    name: "name",
    renderHeader: (rows: any) => (
      <>
        <b>name</b>
      </>
    ),
    renderCell: (row: any) => <>{row.name}</>,
  },
  {
    name: "email",
    renderHeader: (rows: any) => (
      <>
        <b>email</b>
      </>
    ),
    renderCell: (row: any) => <>{row.email}</>,
  },
  {
    name: "id",
    renderHeader: (rows: any) => (
      <>
        <b>id</b>
      </>
    ),
    renderCell: (row: any) => <>{row.id}</>,
  },
  {
    name: "Actions",
    renderHeader: (rows: any) => (
      <>
        <b>Actions</b>
      </>
    ),
    renderCell: (row: any) => <SettingTableAction id={row.id} />,
  },
];

const SettingPage = () => {
  const dispatch = useDispatch();

  const {
    data,
    perPage,
    currentPage,
    totalPage,
    searchTerm,
    loading,
    sortBy,
    sortColumn,
  } = useSelector((state: RootState) => state.setting);

  useEffect(() => {
    const fn = async () => {
      dispatch(setLoading(true));
      try {
        const response = await getSetting();
        if (response.data.status) {
          setTimeout(() => {
            dispatch(setSetting(response.data.data));
          }, 500);
        } else {
          setTimeout(() => {
            dispatch(setSetting(response.data.data));
          }, 500);
        }
      } catch (error) {
        toast.error("Network Error");
      }
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 500);
    };
    fn();
  }, []);

  const handlePerPageChange = useCallback(
    (value: number) => {
      dispatch(setPerPage(value));
      const searchQuery = `${searchTerm}&currentpage=${currentPage}&perPage=${value}`;
      doSearch(searchQuery);
    },
    [dispatch, currentPage, perPage, searchTerm]
  );

  const handlePageChange = useCallback(
    (value: number) => {
      dispatch(setCurrentPage(value));
      const searchQuery = `${searchTerm}&currentpage=${value}&perPage=${perPage}`;
      doSearch(searchQuery);
    },
    [dispatch, currentPage, perPage, searchTerm]
  );

  const handleSearchParams = useCallback(
    (value: string) => {
      dispatch(setCurrentPage(1));
      dispatch(setSearchTerm(value));
      const searchQuery = `${value}&currentpage=${currentPage}&perPage=${perPage}`;
      doSearch(searchQuery);
    },
    [currentPage, perPage, dispatch]
  );

  const handleAfterSearch = useCallback((value: string) => {}, []);

  const { doSearch, searchLoading } = useSearchApi(
    getSetting,
    handleAfterSearch
  );

  const configuration: TTableProps = {
    columns: columns,
    rows: data,
    showPagination: true,
    showSearch: true,
    showPerPage: true,
    showFilter: false,
    paginationData: {
      perPage: perPage,
      currentPage: currentPage,
      totalPage: totalPage,
    },
    onPageChange: handlePageChange,
    onPerPageChange: handlePerPageChange,
    handleSearchParams: handleSearchParams,
    searchPlaceholder: "Search Settings",
  };
  const navigate = useNavigate();
  if (loading) {
    return <TableSkeleton rows={10} columns={6} />;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h2>Settings</h2>
        <Button
          variant="primary"
          size="medium"
          handleButtonClick={() => navigate(`add`)}
        >
          Add Setting
        </Button>
      </div>
      <SettingList {...configuration} />
      {searchLoading && (
        <TableLoader isLoading={searchLoading} loadingMessage={"loading"} />
      )}
    </>
  );
};

export default SettingPage;
